// @ts-nocheck
const filterButtons = document.querySelectorAll('.comparison-filter');
const clearButtons = document.querySelectorAll('.clear-filters');
const productSelectors = document.querySelectorAll('.product-selector');
const productOptions = document.querySelectorAll('.product-selector option');
const filterCount = document.getElementById('active-filter-count');
const openPanelButton = document.getElementById('open-filter-panel');
const closePanelButtons = document.querySelectorAll('.close-filters');
const filtersPanel = document.getElementById('comparison-filters');

productSelectors.forEach(el => {
    el.addEventListener('change', e => {
        handleProductChange(e.target);
    });
});

filterButtons.forEach(el => {
    el.addEventListener('click', e => {
        handleFilterChange(e.target);
    });
});

clearButtons.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        filterButtons.forEach(el => {
            el.classList.remove('active');
        });
        resetFilters();
    });
});

openPanelButton.addEventListener('click', e => {
    filtersPanel.classList.add('shown');
})

closePanelButtons.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        filtersPanel.classList.remove('shown');
    });
});

function handleProductChange(selectInput) {

    if (!selectInput.value) {
        return;
    }

    const col = selectInput.dataset.column;
    const resetEls = [
        `.facet-${col}`,
        `.col-${col}-title`,
        `.col-${col}-options`,
        `.col-${col}-price`,
    ];
    const hideEls = [
        `.col-${col}-image`,
        `.col-${col}-link`,
        `.col-${col}-explore`,
    ];

    resetEls.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
            el.innerHTML = '';
        }
    });
    hideEls.forEach(selector => {
        const el = document.querySelector(selector)
        if (el) {
            el.style.display = 'none';
        }
    });

    // const v = selectInput.value.split('|');
    // const productHandle = v[0];
    // let variantTitle = v[1] ? v[1] : 'Default Title';
    // // handle Seville variant titles
    // if (variantTitle === '13' || variantTitle === '15') {
    //     variantTitle = variantTitle + '"';
    // }

    const data = window.compareData[selectInput.value];

    if (!data) {
        return;
    }

    document.querySelector(`#BaseWidth-${col}`).innerHTML = data.BaseWidth;
    document.querySelector(`#Depth-${col}`).innerHTML = data.Depth;
    document.querySelector(`#Height-${col}`).innerHTML = data.Height;
    document.querySelector(`#Volume-${col}`).innerHTML = data.Volume;
    document.querySelector(`#Weight-${col}`).innerHTML = data.Weight;
    document.querySelector(`#AirlineCarryOn-${col}`).innerHTML = data.AirlineCarryOn;
    document.querySelector(`#HandleDropLength-${col}`).innerHTML = data.HandleDropLength;
    document.querySelector(`#StrapLength-${col}`).innerHTML = data.StrapLength.join(' - ');
    document.querySelector(`#FrontZipperPocketHeight-${col}`).innerHTML = data.FrontZipperPocketHeight;
    document.querySelector(`#LinearInches-${col}`).innerHTML = data.LinearInches;
    document.querySelector(`#UseCases-${col}`).innerHTML = data.UseCases;
    document.querySelector(`#AdditionalInfo-${col}`).innerHTML = data.AdditionalInfo;

    let materialsHtml = '<ul class="materials-list">';
    data.Materials.forEach(material => {
        materialsHtml += `<li><img src="${material.img}" width="100" height="100" alt="" />${material.name}</li>`;
    });
    materialsHtml += '</ul>';
    document.querySelector(`#materials-${col}`).innerHTML = materialsHtml;

    document.querySelector(`#LaptopSize-${col}`).innerHTML = data.LaptopSize;
    document.querySelector(`#LaptopWidth-${col}`).innerHTML = data.LaptopWidth;
    document.querySelector(`#LaptopHeight-${col}`).innerHTML = data.LaptopHeight;
    document.querySelector(`#LaptopDepth-${col}`).innerHTML = data.LaptopDepth;

    document.querySelector(`.col-${col}-title`).innerHTML = data.Title;

    const columnImages = document.querySelectorAll(`.col-${col}-image`);
    columnImages.forEach(el => {
        el.setAttribute('src', data.Image);
        el.style.display = 'block';
    })

    const columnLinks = document.querySelectorAll(`.col-${col}-link`);
    columnLinks.forEach(el => {
        el.setAttribute('href', data.Link);
        el.style.display = 'block';
    });

}

function resetFilters() {
    productOptions.forEach(el => {
        el.style.display = 'initial';
    });

    filterCount.innerHTML = '';

    clearButtons.forEach(el => {
        el.style.display = 'none';
    });

    productSelectors.forEach(el => {
        el.value = '';
        const changeEvent = new Event('change');
        el.dispatchEvent(changeEvent);
    });
}

function handleFilterChange(filterButton) {
    let activeFilters = [];

    filterButton.classList.toggle('active');

    filterButtons.forEach(el => {
        if (el.classList.contains('active')) {
            activeFilters.push(el.dataset.value);
        }
    });

    if (!activeFilters.length) {
        resetFilters();
        return;
    }

    clearButtons.forEach(el => {
        el.style.display = 'block';
    });

    productOptions.forEach(el => {
        el.style.display = 'none';
        el.classList.remove('active');
    });

    productOptions.forEach(el => {
        const classes = el.getAttribute('class').split(' ');
        const matches = classes.filter(value => activeFilters.includes(value));
        const parent = el.closest('.product-selector');
        if (matches.length) {
            // non-empty matches means this option has a class in the activeFilters array
            el.style.display = 'initial';
            el.classList.add('active');
        }
        if (parent.value === el.getAttribute('value') && !el.classList.contains('active')) {
            parent.value = '';
            const changeEvent = new Event('change');
            parent.dispatchEvent(changeEvent);
        }
        if (el.classList.contains('default')) {
            el.style.display = 'initial';
        }
    });

    filterCount.innerHTML = ` (${activeFilters.length})`;
};


if (window.location.hash) {
    const targetValue = window.location.hash.replace('#', '');
    filterButtons.forEach(el => {
        if (el.dataset.value === targetValue) {
            handleFilterChange(el);
        }
    });
}
